import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import loader from './loader.svg';
import './styles/main.scss';

export const Loader = () => (
  <img
    src={loader}
    alt="Loading"
  />
);

export const BFLoader = () => (
  <video
    className="brandfolder-loader"
    height="90"
    width="90"
    poster="https://cdn.brandfolder.io/4OQZ5PW1/as/pxmju5-qfr48-21nt37/generic-loader.gif"
  >
    {t('Loading...')}
    <track kind="captions" />
  </video>
);

export const ButtonLoader = ({ className }) => (
  <img
    src="https://cdn.brandfolder.io/4OQZ5PW1/as/pv2ffm-cflif4-9vjcfz/downloading.gif"
    alt="Loading"
    className={`bf-button-loader ${className}`}
  />
);

export const ProcessingLoader = ({ assetQuantity, onClose }) => {
  const [elapsedTime, setElapsedTime] = useState(0);
  const [showClose, setShowClose] = useState(false);

  const messages = {
    0: `${t('Processing')} ${assetQuantity || ''} ${assetQuantity > 1 ? t('assets') : t('asset')}...`,
    3000: t(`Hang tight! We're preparing your fresh, new asset${assetQuantity > 1 ? 's' : ''}...`),
    5000: t('Still working...'),
    25000: t('No really, still working on it...'),
    35000: t('Still processing, refresh the page shortly...'),
  };

  useEffect(() => {
    const timeouts = Object.keys(messages).map((time) => (setTimeout(() => setElapsedTime(time), time)));
    return () => timeouts.forEach((timeout) => clearTimeout(timeout));
  }, []);

  useEffect(() => {
    if (elapsedTime > 3000) {
      setShowClose(true);
    }

    if (elapsedTime >= 35000) {
      window.Rollbar && window.Rollbar.warning("Asset processing exceeded 35 seconds", { elapsedTime }); // eslint-disable-line no-unused-expressions
    }
  }, [elapsedTime]);

  return (
    <React.Fragment>
      <video
        className="downloading-loader"
        autoPlay
        loop
        muted
        playsInline
        poster="https://cdn.brandfolder.io/4OQZ5PW1/as/pv2ffm-cflif4-9vjcfz/downloading.gif"
      >
        Your browser does not support HTML5 video.
      </video>
      <h4 className="processing-copy">{messages[elapsedTime]}</h4>
      {showClose && (
        <button
          className="close-button"
          onClick={onClose}
          type="button"
        >
          <span
            className="bff-close"
          />
        </button>
      )}
    </React.Fragment>
  );
};

ProcessingLoader.propTypes = {
  assetQuantity: PropTypes.number,
  onClose: PropTypes.func,
};

ProcessingLoader.defaultProps = {
  assetQuantity: 0,
  onClose: () => {},
};
